
const element={
    name:"element",
    type:"HTMLElement",
    description:"animation target element",
},duration={
    name:"duration",
    type:"number",
    description:"animation duration in ms, default to 200",
},callback={
    name:"callback",
    type:"():void",
    description:"a callback function. Called when the animation is finished",
};

export const fadeIn={
    id:"fadeIn",
    type:"function",
    description:"applies a fade-in animation to an element",
    overloads:[
        {
            type:"(element:HTMLElement,callback:function):void",
            props:[element,callback],
        },
        {
            type:"(element:HTMLElement,duration:Number,callback:function):void",
            props:[element,duration,callback],
        },
        {
            type:"(element:HTMLElement,display:String,duration:Number,callback:function):void",
            props:[
                element,
                {
                    name:"display",
                    type:"string",
                    description:"element style display value when visible, default to the  element's display value when fadeIn called",
                },
                duration,callback,
            ],
        },
    ],
    returns:{
        type:"HTMLElement",
        description:"the target element",
    },
},fadeOut={
    id:"fadeOut",
    type:"function",
    description:"applies a fade-out animation to an element",
    overloads:[
        {
            type:"(element:HTMLElement,callback:function):void",
            props:[element,callback],
        },
        {
            type:"(element:HTMLElement,duration:Number,callback:function):void",
            props:[element,duration,callback],
        },
    ],
    returns:{
        type:"HTMLElement",
        description:"the target element",
    },
}
